var _mask, _path, _ellipse, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_189_19055",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.5078 16.2441C22.7227 16.6505 22.8867 17.0712 22.9985 17.5001H22.9998C22.8881 17.929 22.724 18.3496 22.5092 18.756C22.0682 19.5901 21.4219 20.348 20.6071 20.9864C19.7923 21.6248 18.825 22.1312 17.7604 22.4767C16.6958 22.8222 15.5548 23 14.4024 23C13.2501 23 12.1091 22.8222 11.0445 22.4767C9.97992 22.1312 9.0126 21.6248 8.1978 20.9864C7.38299 20.348 6.73665 19.5901 6.29568 18.756C6.08084 18.3496 5.9168 17.929 5.80505 17.5001H5.80366C5.91541 17.0712 6.07946 16.6505 6.29431 16.2441C6.73528 15.41 7.38162 14.6521 8.19643 14.0137C9.01123 13.3753 9.97855 12.8688 11.0431 12.5233C12.1077 12.1778 13.2488 12 14.4011 12C15.5534 12 16.6944 12.1778 17.759 12.5233C18.8236 12.8688 19.7909 13.3753 20.6057 14.0137C21.4205 14.6521 22.0669 15.41 22.5078 16.2441Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9985 17.5001L22.0308 17.7522L22.2256 18.5001H22.9985V17.5001ZM22.5078 16.2441L23.3919 15.7768L23.3919 15.7768L22.5078 16.2441ZM22.9998 17.5001L23.9675 17.7522L24.2938 16.5001H22.9998V17.5001ZM22.5092 18.756L21.6251 18.2886L21.6251 18.2886L22.5092 18.756ZM20.6071 20.9864L19.9903 20.1992L19.9903 20.1992L20.6071 20.9864ZM17.7604 22.4767L17.4517 21.5255L17.4517 21.5255L17.7604 22.4767ZM11.0445 22.4767L11.3532 21.5255L11.3532 21.5255L11.0445 22.4767ZM8.1978 20.9864L8.81454 20.1992L8.81454 20.1992L8.1978 20.9864ZM6.29568 18.756L5.41163 19.2234L5.41163 19.2234L6.29568 18.756ZM5.80505 17.5001L6.77275 17.248L6.57789 16.5001H5.80505V17.5001ZM5.80366 17.5001L4.83596 17.248L4.50976 18.5001H5.80366V17.5001ZM6.29431 16.2441L5.41025 15.7768L5.41025 15.7768L6.29431 16.2441ZM8.19643 14.0137L8.81318 14.8008L8.81318 14.8008L8.19643 14.0137ZM11.0431 12.5233L10.7344 11.5722L10.7344 11.5722L11.0431 12.5233ZM17.759 12.5233L18.0677 11.5722L18.0677 11.5722L17.759 12.5233ZM20.6057 14.0137L19.989 14.8008L19.989 14.8008L20.6057 14.0137ZM23.9662 17.248C23.8344 16.7421 23.6418 16.2494 23.3919 15.7768L21.6238 16.7115C21.8036 17.0517 21.9391 17.4002 22.0308 17.7522L23.9662 17.248ZM22.9998 16.5001H22.9985V18.5001H22.9998V16.5001ZM23.3933 19.2234C23.6431 18.7507 23.8357 18.2581 23.9675 17.7522L22.0321 17.248C21.9404 17.6 21.805 17.9485 21.6251 18.2886L23.3933 19.2234ZM21.2238 21.7735C22.1384 21.057 22.8805 20.1933 23.3933 19.2234L21.6251 18.2886C21.256 18.9869 20.7054 19.639 19.9903 20.1992L21.2238 21.7735ZM18.0691 23.4278C19.2361 23.0491 20.3095 22.4899 21.2238 21.7735L19.9903 20.1992C19.2751 20.7596 18.4139 21.2133 17.4517 21.5255L18.0691 23.4278ZM14.4024 24C15.6564 24 16.9018 23.8066 18.0691 23.4278L17.4517 21.5255C16.4897 21.8377 15.4531 22 14.4024 22V24ZM10.7358 23.4278C11.9031 23.8066 13.1484 24 14.4024 24V22C13.3518 22 12.3152 21.8377 11.3532 21.5255L10.7358 23.4278ZM7.58106 21.7735C8.49537 22.4899 9.56882 23.0491 10.7358 23.4278L11.3532 21.5255C10.391 21.2133 9.52983 20.7596 8.81454 20.1992L7.58106 21.7735ZM5.41163 19.2234C5.92439 20.1933 6.66651 21.057 7.58106 21.7735L8.81454 20.1992C8.09948 19.639 7.54891 18.9869 7.17974 18.2886L5.41163 19.2234ZM4.83736 17.7522C4.96915 18.2581 5.16176 18.7507 5.41163 19.2234L7.17974 18.2886C6.99993 17.9485 6.86445 17.6 6.77275 17.248L4.83736 17.7522ZM5.80366 18.5001H5.80505V16.5001H5.80366V18.5001ZM5.41025 15.7768C5.16037 16.2494 4.96775 16.7421 4.83596 17.248L6.77136 17.7522C6.86307 17.4002 6.99855 17.0517 7.17838 16.7115L5.41025 15.7768ZM7.57968 13.2265C6.66512 13.9431 5.92301 14.8068 5.41025 15.7768L7.17838 16.7115C7.54755 16.0132 8.09812 15.3611 8.81318 14.8008L7.57968 13.2265ZM10.7344 11.5722C9.56744 11.9509 8.49399 12.5101 7.57967 13.2265L8.81318 14.8008C9.52847 14.2404 10.3897 13.7868 11.3518 13.4745L10.7344 11.5722ZM14.4011 11C13.1471 11 11.9017 11.1934 10.7344 11.5722L11.3518 13.4745C12.3138 13.1623 13.3505 13 14.4011 13V11ZM18.0677 11.5722C16.9005 11.1934 15.6551 11 14.4011 11V13C15.4517 13 16.4883 13.1623 17.4503 13.4745L18.0677 11.5722ZM21.2225 13.2265C20.3082 12.5101 19.2347 11.9509 18.0677 11.5722L17.4503 13.4745C18.4125 13.7868 19.2737 14.2404 19.989 14.8008L21.2225 13.2265ZM23.3919 15.7768C22.8791 14.8068 22.137 13.9431 21.2225 13.2265L19.989 14.8008C20.704 15.3611 21.2546 16.0132 21.6238 16.7115L23.3919 15.7768Z",
    fill: "#2E4890",
    mask: "url(#path-1-inside-1_189_19055)"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 14.4,
    cy: 17.5001,
    rx: 3.43895,
    ry: 3.49997,
    fill: "#2E4890"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 1.20091,
    height: 22,
    fill: "#2E4890"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 2.20093,
    y: 1,
    width: 13.21,
    height: 1.22222,
    fill: "#2E4890"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 3.40186,
    y: 4.66675,
    width: 9.60731,
    height: 1.22222,
    fill: "#2E4890"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 15.411,
    y: 2.22229,
    width: 1.20091,
    height: 3.66667,
    fill: "#2E4890"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 14.2101,
    y: 2.22229,
    width: 1.20091,
    height: 3.66667,
    fill: "#2E4890"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 16.6119,
    y: 3.44446,
    width: 1.20091,
    height: 2.44444,
    fill: "#2E4890"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 3.40186,
    y: 8.33325,
    width: 9.60731,
    height: 1.22222,
    fill: "#2E4890"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 3.40186,
    y: 12,
    width: 3.60274,
    height: 1.22222,
    fill: "#2E4890"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 2.20093,
    y: 21.7777,
    width: 4.80365,
    height: 1.22222,
    fill: "#2E4890"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 17.8129,
    y: 4.66675,
    width: 1.20091,
    height: 7.33333,
    fill: "#2E4890"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHistory);
export default __webpack_public_path__ + "static/media/icon_history.51f4c3b7f8a66c148cff4286e4eb0dd4.svg";
export { ForwardRef as ReactComponent };